import { useEffect, useRef, useState } from "react";
import radioactiveSymbol from "../../assets/radioactive-symbol.png";

// Get app URL
const appURL = process.env.BUN_PUBLIC_WEBSITE_URL ?? "http://localhost:3000";

export function TreasurePage({ onBack, token }: { onBack: () => void; token: string | null }) {
  const [secretMessage, setSecretMessage] = useState<string>("Chargement...");
  const [error, setError] = useState<string | null>(null);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;
    if (!token) {
      setError("Accès refusé !");
      return;
    }
    fetch(`${appURL}/api/treasure`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then(async (res) => {
        const data = await res.json();
        if (data.code == 200) {
          setSecretMessage(data.message);
        } else {
          setError(data.message ?? "Accès refusé !");
        }
      })
      .catch(() => setError("Erreur de connexion au système."));
  }, [token]);

  return (
    <div className="relative z-10 w-full max-w-2xl mx-auto p-8 flex flex-col items-center">
      <div className="hazard-stripes fixed top-0 left-0 right-0 h-4 z-20" />
      <div className="hazard-stripes fixed bottom-0 left-0 right-0 h-4 z-20" />

      <div className="flicker flex items-center gap-4 border-2 border-[#f5c518] bg-[#1a1a1a]/90 px-6 py-4 mb-8 w-full">
        <img
          src={radioactiveSymbol}
          alt="Symbole radioactif"
          className="radiation-animate radioactive-yellow w-12 h-12 shrink-0 opacity-90"
        />
        <div className="flex-1 text-left">
          <p className="text-3xl font-bold text-[#f5c518] uppercase tracking-widest leading-tight">
            Accès autorisé
          </p>
          <p className="text-sm text-[#9a9a85] uppercase tracking-[0.2em] mt-1">
            Salle débloquée · niveau C
          </p>
        </div>
      </div>

      <div className="w-full border border-[#3a3f2a] bg-[#14170f]/80 p-8 space-y-6 relative text-center">
        <div className="absolute -top-3 left-6 uppercase text-[10px] tracking-[0.3em] text-[#39ff14]/80 bg-[#0a0d08] px-2">
          Contenu scellé
        </div>

        {error ? (
          <p className="uppercase tracking-[0.25em] text-sm text-red-400">{error}</p>
        ) : (
          <p className="text-[#9a9a85] uppercase tracking-[0.25em] text-sm">{secretMessage}</p>
        )}

        <button
          onClick={onBack}
          className="danger-glow uppercase font-bold tracking-[0.3em] text-lg text-black bg-[#f5c518] hover:bg-[#ffd93d] px-6 py-3 transition-colors"
        >
          Revenir
        </button>
      </div>
    </div>
  );
}
